__turbopack_context__.v({
  "fieldset": "DesktopFilters-module-scss-module__UqHWyq__fieldset",
  "form": "DesktopFilters-module-scss-module__UqHWyq__form",
  "label": "DesktopFilters-module-scss-module__UqHWyq__label",
  "legend": "DesktopFilters-module-scss-module__UqHWyq__legend",
  "radio": "DesktopFilters-module-scss-module__UqHWyq__radio",
  "radio_label": "DesktopFilters-module-scss-module__UqHWyq__radio_label",
  "scroll_to_top_button": "DesktopFilters-module-scss-module__UqHWyq__scroll_to_top_button",
  "scroll_to_top_button__displayed": "DesktopFilters-module-scss-module__UqHWyq__scroll_to_top_button__displayed",
  "sort_by": "DesktopFilters-module-scss-module__UqHWyq__sort_by",
});
